import React from 'react';

type SvgWarningProps = {
  width?: number;
  height?: number;
};

const SvgWarning = ({ width = 16, height = 16 }: SvgWarningProps): JSX.Element => (
  <svg width={width} height={height} xmlns='http://www.w3.org/2000/svg'>
    <title>Warning</title>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.806 13.027a1.127 1.127 0 0 1-1.58 0 1.1 1.1 0 0 1-.325-.778c0-.288.118-.572.326-.777a1.134 1.134
      0 0 1 1.579 0c.21.205.328.489.328.777 0 .29-.118.574-.328.778Zm-.788-8.22c.912 0 1.134.674 1.078
      1.061l-.547 4.19a.526.526 0 0 1-.531.523c-.24 0-.51-.124-.532-.523l-.547-4.19c-.056-.398.172-1.062
      1.079-1.062Zm7.34 7.844L9.122 2.017a1.28 1.28 0 0 0-1.106-.628c-.457 0-.878.24-1.107.628L.63 12.727a1.24
      1.24 0 0 0 0 1.258c.228.389.65.628 1.106.628H14.3c.706 0 1.277-.563 1.277-1.257a1.24 1.24 0 0 0-.22-.705Z'
      fill='currentColor'
    />
  </svg>
);

export default SvgWarning;
